import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import Dashboard from 'portal/src/components/common/Dashboard';
import { DASHBOARD_SLUGS } from 'portal/src/constants/luzmoDashboards';

import { RouteDefinition } from '../routeGenerator';

export const electricRouteDefinitions: RouteDefinition[] = [
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_ELECTRIC.USAGE} />
    ),
    name: 'Aggregated Usage',
    path: NESTED_ROUTES.INTERVAL_DATA_ELECTRIC.USAGE,
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_ELECTRIC.MAP} />
    ),
    name: 'Usage Map',
    path: NESTED_ROUTES.INTERVAL_DATA_ELECTRIC.MAP,
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_ELECTRIC.HEATMAP}
      />
    ),
    name: 'Electric Heatmap',
    path: NESTED_ROUTES.INTERVAL_DATA_ELECTRIC.HEATMAP,
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_ELECTRIC.METRICS}
      />
    ),
    name: 'Demand Metrics',
    path: NESTED_ROUTES.INTERVAL_DATA_ELECTRIC.METRICS,
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_ELECTRIC.TRENDS}
      />
    ),
    name: 'Demand Trends',
    path: NESTED_ROUTES.INTERVAL_DATA_ELECTRIC.TRENDS,
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_ELECTRIC.PROFILES}
      />
    ),
    name: 'Demand Profiles',
    path: NESTED_ROUTES.INTERVAL_DATA_ELECTRIC.PROFILES,
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_ELECTRIC.POINTS}
      />
    ),
    name: 'All Electric Points',
    path: NESTED_ROUTES.INTERVAL_DATA_ELECTRIC.POINTS,
  },
];
